import { getNotification } from "../../../utils/common";
import { notifyIcon } from "../../../config";

/**
 * Utility functions for PDF export
 */

/**
 * Handle PDF export attempt with proper error handling
 */
export const attemptPDFExport = (pdfExportRef, dispatch, setExportTask, setFormData) => {
  try {
    if (pdfExportRef.current && typeof pdfExportRef.current.save === 'function') {
      const savePromise = pdfExportRef.current.save();
      if (savePromise && typeof savePromise.then === 'function') {
        savePromise
          .then(() => {
            getNotification("PDF exported successfully", notifyIcon.SUCCESS_ICON);
          })
          .catch((error) => {
            console.error("Error during PDF save:", error);
            getNotification("PDF export failed", notifyIcon.ERROR_ICON);
          })
          .finally(() => {
            dispatch(setExportTask({ isExporting: false }));
            setFormData(null);
          });
      } else {
        getNotification("PDF exported successfully", notifyIcon.SUCCESS_ICON);
        dispatch(setExportTask({ isExporting: false }));
        setFormData(null);
      }
    } else {
      console.error("PDF export reference is not available, retrying...");
      setTimeout(() => attemptPDFExport(pdfExportRef, dispatch, setExportTask, setFormData), 500);
    }
  } catch (error) {
    console.error("Error during PDF export:", error);
    getNotification(`PDF export failed: ${error.message}`, notifyIcon.ERROR_ICON);
    dispatch(setExportTask({ isExporting: false }));
    setFormData(null);
  }
};

/**
 * Create task data object from Redux state
 */
export const createTaskData = (task, priority, stage, formatDate, assigneeList) => ({
  ticketId: task?.ProjectTaskId,
  title: task?.Name,
  createdBy: task?.CreatedByName ?? "Automation",
  created: formatDate(task?.CreatedOn),
  dueDate: formatDate(task?.DueDate),
  priority: priority?.label,
  status: stage?.label,
  description: task?.Description,
  isCompleted: stage?.label?.toLowerCase() === 'completed',
  projectName: task?.ProjectName,
  assigneeName: assigneeList?.find((user) => user.value === task?.CurrentAssignee)?.label || "Unassigned",
  currentStage: stage?.label
});

/**
 * Check if section should be rendered
 */
export const shouldRenderSection = (exportTask, sectionKey) => {
  return exportTask?.sections?.includes(sectionKey);
};
